var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 3.33203H5.66699C4.26686 3.33203 3.5668 3.33203 3.03202 3.60452C2.56161 3.8442 2.17916 4.22665 1.93948 4.69706C1.66699 5.23183 1.66699 5.9319 1.66699 7.33203V14.332C1.66699 15.7322 1.66699 16.4322 1.93948 16.967C2.17916 17.4374 2.56161 17.8199 3.03202 18.0595C3.5668 18.332 4.26686 18.332 5.66699 18.332H12.667C14.0671 18.332 14.7672 18.332 15.302 18.0595C15.7724 17.8199 16.1548 17.4374 16.3945 16.967C16.667 16.4322 16.667 15.7322 16.667 14.332V10.832",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8212 6.45524L13.5448 4.1788M7 13L8.92608 12.786C9.1614 12.7598 9.27906 12.7468 9.38903 12.7112C9.4866 12.6796 9.57946 12.635 9.66507 12.5785C9.76158 12.5149 9.84529 12.4312 10.0127 12.2637L17.5285 4.74791C18.1572 4.11929 18.1572 3.10009 17.5285 2.47147C16.8999 1.84285 15.8807 1.84284 15.2521 2.47147L7.73627 9.98729C7.56885 10.1547 7.48514 10.2384 7.4215 10.3349C7.36505 10.4205 7.32042 10.5134 7.28883 10.611C7.25323 10.7209 7.24016 10.8386 7.21401 11.0739L7 13Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionEdit);
export default __webpack_public_path__ + "static/media/action_edit.4930925e0cb58c7304570765d4f13dcf.svg";
export { ForwardRef as ReactComponent };